var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var IpcPthPadGeneratorInteractionModel = require('./ipcPthPadGeneratorInteractionModel.js');

var DipPadGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    IpcPthPadGeneratorInteractionModel.apply(this, arguments);

    this.leadSpan = this.shadow("leadSpan",
        function() {
            return this.data.leadSpan() / this.getUnitFactor();
        },
        function(value) {
            return this.data.leadSpan(parseFloat(value) * this.getUnitFactor());
        }, 
        [
            this.data.leadSpan, this.userSettingsModel.distanceUnit
        ]
    );

    this.terminalThickness = this.shadow("terminalThickness",
        function() {
            return this.data.terminalThickness() / this.getUnitFactor();
        },
        function(value) {
            return this.data.terminalThickness(parseFloat(value) * this.getUnitFactor());
        }, 
        [
            this.data.terminalThickness, this.userSettingsModel.distanceUnit
        ]
    );

    this.bodyOffset = this.shadow("bodyOffset",
        function() {
            return this.data.bodyOffset() / this.getUnitFactor();
        },
        function(value) {
            return this.data.bodyOffset(parseFloat(value) * this.getUnitFactor());
        }, 
        [
            this.data.bodyOffset, this.userSettingsModel.distanceUnit
        ]
    );
};

lib_core.inherit(DipPadGeneratorInteractionModel, IpcPthPadGeneratorInteractionModel);
DipPadGeneratorInteractionModel.$class = 'DipPadGeneratorInteractionModel';

module.exports = DipPadGeneratorInteractionModel;

DipPadGeneratorInteractionModel.prototype.getInspectorElementForLeadSpan = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('E', this.LCLZ('leadSpan', 'Lead Span'), this.leadSpan, this.userSettingsModel.distanceUnit)];
};

DipPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalThickness = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('c', this.LCLZ('terminalThickness', 'Terminal Thickness'), true, null, false, this.terminalThickness, this.userSettingsModel.distanceUnit)];
};

DipPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E1', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

DipPadGeneratorInteractionModel.prototype.getInspectorElementForBodyOffset = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('A1', this.LCLZ('bodyOffset', 'Body Offset'), this.bodyOffset, this.userSettingsModel.distanceUnit)];
};

DipPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalThickness());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyOffset());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForPadHoleRatio());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};